import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsConfigEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsConfigEntity
